<template>
  <el-form>
    <template v-if="step === 1">
      <h2>What is your email address?</h2>
    </template>

    <el-form-item label="Email address" :error="error" required>
      <el-input v-model="form.email" placeholder="Enter your email address" />
    </el-form-item>

    <template v-if="step === 1">
      <p class="terms">
        By clicking on Submit you agree to our <el-button type="text" @click="privacy">Privacy Policy</el-button>
        applicable to the processing of your personal data.
      </p>

      <el-button type="primary" class="full" @click="submit">Submit</el-button>
    </template>

    <template v-else-if="step === 2">
      <el-form-item label="Password" :error="confirmError" required>
        <el-input
          v-model="form.password"
          type="password"
          placeholder="Enter password"
        />

        <el-input
          v-model="form.confirm"
          type="password"
          class="confirm"
          placeholder="Confirm your password"
        />
      </el-form-item>

      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="First name" :error="nameError" required>
            <el-input
              v-model="form.firstName"
              placeholder="Enter first name"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Last name" :error="nameError" required>
            <el-input
              v-model="form.lastName"
              placeholder="Enter last name"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <vue-recaptcha
        ref="recaptcha"
        class="recaptcha"
        :sitekey="$root.recaptchaKey"
        :loadRecaptchaScript="true"
        @verify="verify"
        @expired="expired"
      />

      <el-button
        type="primary"
        :loading="loading"
        :disabled="!form['g-recaptcha-response']"
        @click.prevent="signup"
      >
        Sign up
      </el-button>
    </template>
  </el-form>
</template>

<script>
import isEmail from 'validator/lib/isEmail'
import VueRecaptcha from 'vue-recaptcha'

export default {
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  components: {
    VueRecaptcha
  },
  data () {
    return {
      loading: false,
      error: null,
      nameError: null,
      confirmError: null,
      form: {
        email: null,
        firstName: null,
        lastName: null,
        password: null,
        confirm: null
      }
    }
  },
  methods: {
    submit () {
      this.error = null

      if (this.form.email && isEmail(this.form.email)) {
        this.$emit('update:step', 2)
      } else {
        this.error = 'Your email is incorrect. Please check, and try again.'
      }
    },
    signup () {
      if (!this.form.email || !isEmail(this.form.email)) {
        this.error = 'Your email is incorrect. Please check, and try again.'
        return
      }

      if (!this.form.firstName || !this.form.lastName) {
        this.nameError = 'You must enter a first and last name.'
        return
      }

      if (!this.form.password || this.form.password !== this.form.confirm) {
        this.confirmError = 'Your password is incorrect. Please check, and try again.'
        return
      }

      this.loading = true
      this.$store.dispatch('signup', this.form)
        .then(() => {
          this.$gtm.trackEvent({
            event: 'signup'
          })
          this.$router.push(this.$route.path)
        })
        .catch(() => {
          this.loading = false
          this.error = 'Your email already exist. Please check, and try again.'
          this.$refs.recaptcha.reset()
        })
    },
    privacy () {
      window.open('https://www.runstack.com/privacy', '_blank')
    },
    verify (recaptcha) {
      this.$set(this.form, 'g-recaptcha-response', recaptcha)
    },
    expired () {
      this.form['g-recaptcha-response'] = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-button {
    &.full {
      width: 100%;
      text-align: center;
      margin-top: 25px;
    }
    &.el-button--primary {
      margin-bottom: 40px;
    }
    & + .el-button {
      margin-left: 0;
    }
  }

  .recaptcha {
    margin-bottom: 15px
  }

  .confirm {
    margin-top: 12px;
  }
</style>
